import PropTypes from 'prop-types';

const propType = {
  appName: PropTypes.string,
  primaryColor: PropTypes.string,
  primaryText: PropTypes.string,
  horizontalLogo: PropTypes.string,
  squareLogo: PropTypes.string,
  mobileStoreIcon: PropTypes.string,
  favicon: PropTypes.string,
  headBackground: PropTypes.string,
  headBackgroundResponsive: PropTypes.string,
};

export default { propType };
